import { useTemplateList } from '@pages/PackageHub/Template/utils';
import { theme } from '@prophecy/theme';
import { Stack, Centered, Spinner } from '@prophecy/ui-v3';

import { PackageBanner } from '../components/PackageBanner';
import { TemplateFilter } from '../components/TemplateFilter';
import { TemplateList } from './TemplateList';

export const TemplateHub = () => {
  const { setFilter, filter, data, isLoading, teamNames, templates } = useTemplateList();
  if (isLoading) {
    return (
      <Centered>
        <Spinner />
      </Centered>
    );
  }
  if (!data) {
    return null;
  }

  return (
    <Stack gap={theme.spaces.x40}>
      <PackageBanner
        heading='Template Hub'
        subHeading='Explore, Utilize, and deploy from Pre-built templates and Sample Data'
        description='Discover a rich ecosystem of gems, functions, and pipelines templates to jumpstart your data analysis'
      />
      <TemplateFilter filter={filter} setFilter={setFilter} teamNames={teamNames} templates={templates} />
      <TemplateList templates={templates} />
    </Stack>
  );
};
